import { ActeOperations } from "../components/acces-operation-binder.component";
import { AccesDemandeIntervention } from '../entities/acces-demande-intervention.entity';
import { Notification } from "./notification.entity";
import { WorkOrder } from "./work-order.entity";

export class AccesBindedElement {
	
	accesId!: number;
	demandeInterventions: AccesDemandeIntervention[] = [];
	acteOperations!: ActeOperations;
	workOrders: WorkOrder[] = [];
	notifications: Notification[] = [];
	
	constructor(accesId: number, demandeInterventions: AccesDemandeIntervention[], acteOperations: ActeOperations, workOrders: WorkOrder[], notifications: Notification[]) {
		this.accesId = accesId;
		this.demandeInterventions = demandeInterventions;
		this.acteOperations = acteOperations;
		this.workOrders = workOrders;
		this.notifications = notifications;
	}

}